module.exports = __webpack_public_path__ + "static/pubal-69bc55dc9f9a5349ad053041a03c5c6a.svg";